/*
 *
 * OperationCustomerInfo
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 04-Dec-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage from './languageModule'
import './OperationCustomerInfo.scss'

const OperationCustomerInfo = ({ customerInfo, isLoading }) => {
  const buildFields = (address = {}) => ({
    name: address?.name || '-',
    street: address?.street || '-',
    city: address?.city || '-',
    postCode: address?.postCode || '-',
    province: address?.province || '-',
    country: address?.country || '-',
    additionalInfo: address?.additionalInfo || '-',
  });

  const billingFields = buildFields(customerInfo?.billingAddress);
  const shippingFields = buildFields(customerInfo?.shippingAddress);

  const acceptanceMap = {
    true: formattedMessage.yes,
    false: formattedMessage.no
  };

  const mainField = {
    cardHolderName: customerInfo?.cardHolderName || '-',
    cardHolderEmail: customerInfo?.cardHolderEmail || '-',
    mobilePhone: customerInfo?.mobilePhone ? (customerInfo?.mobilePhoneCountryCode ?? '') + customerInfo.mobilePhone : '-',
    tin: customerInfo?.tin || '-',
    recontactConsent: acceptanceMap[String(customerInfo?.recontactConsent)] || '-', 
  }

  const renderFields = (fields) => (
    <div className='text_field_section'>
      {Object.entries(fields).map(([field, value]) => (
        <PortalTextBlocked
          key={`operation-customer-info-field-${field}`}
          label={formattedMessage[field]}
          value={value}
          isLoading={isLoading}
          noPadding
        />
      ))}
    </div>
  );

  return (
    <div className='operationDetailCustomerInfo'>
      <div className='first_group'>
        <div className='text_field_section'>
          {Object.entries(mainField).map(([field, value]) => (
            <PortalTextBlocked
              key={`operation-customer-info-mainField-${field}`}
              label={formattedMessage[field]}
              value={value || '-'}
              isLoading={isLoading}
              noPadding
            />
          ))}
        </div>
      </div>
      <div className='second_group'>
        <h3 className='subtitle'>{formattedMessage.billingAddress}</h3>
        {renderFields(billingFields)}
      </div>
      <div className='third_group'>
        <h3 className='subtitle'>{formattedMessage.shippingAddress}</h3>
        {renderFields(shippingFields)}
      </div>
    </div>
  );
};

OperationCustomerInfo.propTypes = {
  customerInfo: PropTypes.object,
  isLoading: PropTypes.bool
}

OperationCustomerInfo.defaultProps = {
  customerInfo: {},
  isLoading: false
}

export default OperationCustomerInfo
